/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import React, { PureComponent } from 'react';
import CustomJewelryPageComponent from './CustomJewelryPage.component';
import JewelryInquiryDispatcher from 'Store/JewelryInquiry/JewelryInquiry.dispatcher';
import { connect } from 'react-redux';
import { jewelrytype } from './CustomJewelryPage.type';

export const mapStateToProps = (state) => ({
    isLoading: state.JewelryInquiryReducer.isLoading,
});

export const mapDispatchToProps = (dispatch) => ({
    sendMessage: (data) => JewelryInquiryDispatcher.prepareRequest(data, dispatch),
});

export class CustomJewelryPageContainer extends PureComponent {
    static propTypes = {
        currentUrl: this.propTypes,
        match: this.propTypes,
        sendMessage: this.propTypes,
        isLoading: this.propTypes
    };

    containerFunctions = {
        onFormSubmit: this.onFormSubmit.bind(this),
    };

    containerProps() {
        const {
            currentUrl,
            match,
            isLoading
        } = this.props;

        return {
            currentUrl,
            match,
            isLoading
        };
    }

    onFormSubmit(form, fields) {
        const { sendMessage } = this.props;
        const filteredFields = {};

        fields?.forEach(({ name, value }) => {
            filteredFields[name] = String(value);
        });

        const jewelrytypelabel = jewelrytype?.find((value => value?.id === Number(filteredFields?.jewelrytype)));

        sendMessage({ form, fields: { ...filteredFields, jewelrytype: jewelrytypelabel?.name } });
    }

    render() {
        return (
            <CustomJewelryPageComponent
                {...this.containerProps()}
                {...this.containerFunctions}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomJewelryPageContainer);
